import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const STORAGE_KEY = 'cxb_cookie_consent';

function CookieConsent() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch (_) {}
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch (_) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookieConsent" role="dialog" aria-label={t('common.cookieConsent')}>
      <p>
        {t('search.message', { privacyPolicy: <Link to="/legal">{t('footer.privacyPolicy')}</Link> })}
      </p>
      <button type="button" className="cookieConsentBtn" onClick={accept}>
        {t('search.agree')}
      </button>
    </div>
  );
}

export default CookieConsent;
